import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const Container = styled(Flex)`
  width: 100%;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
    padding: ${theme.spacing(0, 2)};
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(4)};
      padding: ${theme.spacing(0, 5)};
    }
  `}
  max-width: ${({ theme }) => theme.breakpoints.xl};
  margin-left: auto;
  margin-right: auto;
`;

export const ContentWrapper = styled(Box)`
  width: 100%;
  ${({ theme }) => css`
    background-color: ${theme.colors.primaryBlue};
  `}
`;
export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  ${({ theme }) => css`
    padding: ${theme.spacing(4)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(5)};
    }
  `}
`;

export const ContactData = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${({ theme }) => css`
    padding: ${theme.spacing(4)};
    gap: ${theme.spacing(4)};
    ${theme.media.md.up} {
      min-width: 700px;
      flex-direction: row;
      justify-content: space-between;
    }
  `}
`;

export const IconWrapper = styled(Box)`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  height: ${({ theme }) => theme.spacing(4)};
  width: ${({ theme }) => theme.spacing(4)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: center;
`;

export const Item = styled(Flex)`
  cursor: pointer;
  white-space: nowrap;
  flex: 1;
`;
